import React from "react";
import "./OurChecklist.css";

const OurChecklist = () => {
  return (
    <div className="check-bg">
      <div className="check-content">
        <h1>Our Checklist for Planning Your Perfect Event</h1>
        <hr />
        <ul>
          <li>Establish the event specifics and objectives</li>
          <li>Keep everyone on the invite list updated</li>
          <li>Create a cheerful and fun atmosphere</li>
          <li>
            Fix any possible issues that occur during the event on the fly
          </li>
          <li>Make sure guests feel welcomed and engaged in the celebration</li>
          <li>Keep your event flowing smoothly and in timely manner</li>
        </ul>
      </div>
    </div>
  );
};

export default OurChecklist;
